import React from "react";
import "./Accordion.css";
import security from "./accor.png";
import crome from "./Chrome@2x.png";

const Accordion = () => {
  const accordionData = [
    {
      id: "collapseTwo",
      title: "Secure & Quick Payment Processing",
      description:
        "Make payments instantly and safely. Track all transactions, view invoices, and get reminders for pending bills — all in one app designed for ISPs and their clients."
    },
    {
      id: "collapseThree",
      title: "Real-Time Usage & Billing Insights",
      description:
        "Monitor your internet usage and billing details in real-time. Get detailed reports, usage trends, and notifications about your consumption to avoid surprises and manage your payments efficiently."
    },
    {
      id: "collapseFour",
      title: "Manage Your Bills & Payments Easily",
      description:
        "View all your bills, track payment history, and pay securely from any device. Get instant notifications for new bills and upcoming due dates, making billing management simple and hassle-free."
    }
  ];

  return (
    <div style={{ zIndex: 1 }} className="container pb-5">
      <div class="row row-cols-lg-2 row-cols-1">
        <div class="col-12 col-lg-6 p-sm-5 ">
          <button className="notero-button btn">
            Smooth and Easy Management
          </button>

          <h1 className="fw-bolder py-2 ">
            Secure <span className="text-color">Billing & Payments </span>
          </h1>
          <p>
            View your bills, track payment history, and complete transactions
            safely from any device with ease.
          </p>

          <div className="accordion rounded-4" id="accordionExample">
            {accordionData?.map((item, index) => (
              <div className="accordion-item" key={item.id}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button fw-bolder ${
                      index !== 0 ? "collapsed" : ""
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${item.id}`}
                    aria-expanded={index === 0 ? "true" : "false"}
                    aria-controls={item.id}
                  >
                    {item.title}
                  </button>
                </h2>

                <div
                  id={item.id}
                  className={`accordion-collapse collapse ${
                    index === 0 ? "show" : ""
                  }`}
                  data-bs-parent="#accordionExample"
                >
                  <div
                    style={{ textAlign: "justify" }}
                    className="accordion-body rounded"
                  >
                    {item.description}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="crome-boton-color btn rounded-pill px-3 mt-5">
            <div className="d-flex align-items-center">
              <div>
                <img src={crome} width={"54px"} alt="" />
              </div>{" "}
              <span className="dag">|</span>
              <div className="crome text-start">
                <small>Available In The</small>
                <br />
                <b>Chrome Web Store</b>
              </div>
            </div>
          </button>
        </div>

        <div className="col-12 col-lg-6 bubble note text-center">
          <div id="">
            <img className="img-fluid p-sm-5 " src={security} alt="" />
            <div className="d-none d-lg-block d-xl-block" id="security1"></div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Accordion;
